// Copyright © 2021 Move Closer
import { ArticlesListVersion } from './ArticlesList.contracts';
/**
 * Counts the articles for the passed-in size and version configuration.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const getArticlesCount = (moduleSize, moduleVersion) => {
    const { rowSpan } = moduleSize;
    switch (moduleVersion) {
        case ArticlesListVersion.Thumbnails: {
            return Math.ceil(rowSpan * 1.5);
        }
        case ArticlesListVersion.Text:
        default: {
            return rowSpan * 3;
        }
    }
};
